













import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class PaginationCmp extends Vue {
  @Prop()
  private totalNum: any;
  @Prop()
  private currentPage: any;
  @Prop()
  private ifSmall: any;
  private handleCurrentChange(val) {
    this.$emit("current-page-change", val);
  }
}
